import axios from "axios";
import type { Cities } from "../../domain/entities/Cities";
import { ApiConfig } from "../config/apiConfig";

export class CitiesApi {
  async getCities(stateId: string): Promise<Cities[]> {
    const response = await axios.get(ApiConfig.CITIES, {
      params: {
        state_id: stateId,
      },
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return response.data.data.cities.map((city: any) => ({
      id: city.id,
      name: city.name,
      state_id: city.state_id,
      pincode: city.pincode,
      created_at: city.created_at,
    }));
  }
}
